<template>
  <div v-if="input">
    <v-layout wrap class="my-3">
      <v-flex xs6> Warroom Client ID </v-flex>
      <v-flex xs6 class="text-xs-right">
        <v-text-field
          v-model="input.warroom_clientid"
          class="default-input mb-2"
          outline
          name="warroom_clientid"
          hide-details
          single-line
          clearable
          maxlength="500"
          :placeholder="$t('Warroom Client ID')"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap class="my-3">
      <v-flex xs6> Warroom Client Secret </v-flex>
      <v-flex xs6 class="text-xs-right">
        <v-text-field
          v-model="input.warroom_client_secret"
          class="default-input mb-2"
          outline
          name="warroom_client_secret"
          hide-details
          single-line
          clearable
          maxlength="500"
          :placeholder="$t('Warroom Client Secret')"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap class="my-3">
      <v-flex xs6> Use warroom production endpoint </v-flex>
      <v-flex xs6 class="text-xs-right">
        <toggle-button
          :value="input.use_warroom_endpoint_production"
          :sync="true"
          :color="$vuetify.theme.success"
          :labels="{ checked: 'ON', unchecked: 'OFF' }"
          style="display: inline-block"
          @change="handleChangeUseWarroomEndpointProduction()"
        />
      </v-flex>
    </v-layout>
    <div class="text-xs-center mt-2 mb-2">
      <v-btn outline color="grey" @click="$emit('onCancel')">{{ $t('cancel') }} </v-btn>
      <v-btn depressed color="primary" @click="$emit('onChangeConfig', input)"
        >{{ $t('Save') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  components: {
    ToggleButton
  },
  props: ['value'],
  data() {
    return {
      input: undefined
    }
  },
  mounted() {
    // eslint-disable-next-line no-undef
    this.input = _.cloneDeep(this.value)
  },
  methods: {
    handleChangeUseWarroomEndpointProduction() {
      this.input.use_warroom_endpoint_production = !this.input.use_warroom_endpoint_production
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/AdvancedSetting/WarroomConfigManage.vue